import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=769a468f&scoped=true"
var script = {}
import style0 from "./ContactView.vue?vue&type=style&index=0&id=769a468f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a468f",
  null
  
)

export default component.exports